import { useCallback } from 'react';
import { notification } from 'src/components/Notification';

export default ({ setFieldValue, handleSubmit, errors }) =>
  useCallback(
    async (draft, event) => {
      if (errors.workEmail) {
        notification.error('Please complete the required field in Contacts');
      }
      event.persist();
      await setFieldValue('draft', draft || false);
      handleSubmit(event);
    },
    [setFieldValue, handleSubmit, errors],
  );
